// removed by extract-text-webpack-plugin
module.exports = {"conversation-header":"conversation-header__OVJqdhMgt3PJ"};